"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._CreateBucketConfiguration = {
    type: "structure",
    required: [],
    members: {
        LocationConstraint: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_CreateBucketConfiguration.js.map